module.exports = __webpack_public_path__ + "static/media/edit.26db0be6.svg";